import classnames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { FilterIcon } from '../../../icons/AtomixIcon/FilterIcon'
import classes from './customSelect.module.scss'

export interface Option {
    label: string
    value: string | number
}

export interface Icons {
    up: React.ReactNode
    down: React.ReactNode
}
export type CustomSelectFieldProps = {
    containerProps?: React.HTMLAttributes<HTMLDivElement>
    disabled?: boolean
    htmlInputProps?: React.HTMLAttributes<HTMLSelectElement>
    label: string
    options: Option[]
    value: string | number
    arrowIcons?: Icons
    isFilterIcon?: boolean
    errorText?: string
    onChange: CallableFunction
    onBlur?: CallableFunction
}

export const CustomSelectField:React.FC<PropsWithChildren<CustomSelectFieldProps>> = ({ 
  label: inputLabel,
  options,
  value = '',
  onChange,
  disabled,
  htmlInputProps = {},
  containerProps = {},
  isFilterIcon = false,
  errorText,
  arrowIcons = { up: undefined, down: undefined } }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const maskRef = React.useRef<HTMLDivElement>(null)

  const handleMaskClick: React.MouseEventHandler<HTMLDivElement> =
        React.useCallback(
          (e) => {
            if (e.target === maskRef.current) {
              setIsOpen(false)
            }
          },
          [maskRef],
        )

  const toggling = React.useCallback(() => {
    if (disabled) {
      setIsOpen(false)

      return
    }

    setIsOpen((prev) => !prev)
  }, [])



  const label = value !== '' ? value : inputLabel
  const onClickChange = React.useCallback(
    (newValue: string | number) => () => {
      onChange(newValue)
      setIsOpen(false)
    },
    [],
  )

  React.useEffect(() => {
    setIsOpen(false)
  }, [options])


  const arrowUp = arrowIcons.up || <i className={classes.arrowUp} />
  const arrowDown = arrowIcons.down || <i className={classes.arrowDown} />

  return (

    <div className={classes.customDropDownWrapper}>
      {isOpen && (
        <div aria-hidden="true" ref={maskRef} onClick={handleMaskClick} className={classes.mask}/>
      )}

      <div
        className={classes.dropDownContainer}
        {...containerProps}
      >
        <select
          value={value}
          onChange={(event) => onChange(event.target.value)}
          {...htmlInputProps}
          className={classnames(classes.inputSelect, errorText && classes.error)}
        >
          {value === '' && (<option value={value}>{label}</option>)}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <div
          aria-hidden="true"
          data-testid="selector"
          className={classnames(isOpen ? `${classes.dropDownHeader} ${classes.isOpen}` : `${classes.dropDownHeader}`, errorText && classes.customError)}
          onClick={toggling}
        >
          <span>{label}</span>
          {!isFilterIcon ? (isOpen ? arrowUp : arrowDown) : <FilterIcon />}
        </div>
        {isOpen && (
          <div
            className={classes.dropDownListContainer}
            data-testid="options-container"
          >
            <ul className={classes.dropDownList}>
              {options.map((option) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events
                <li
                  aria-hidden="true"
                  key={option.value}
                  className={classes.listItem}
                  onClick={onClickChange(option.value)}
                >
                  {option.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}